export default __webpack_public_path__ + "static/media/reg-banner.0512d401.png";